import getConfig from 'next/config';
import { NextPageContext } from 'next';
import { UserApiFactory } from './profile';
import { MarusiaApiFactory } from './otvety';

const { publicRuntimeConfig } = getConfig();
const LOCALHOST = publicRuntimeConfig.LOCAL_HOST;
const UCHI_URL = publicRuntimeConfig.UCHI_URL;
const INTERNAL_API_URL = publicRuntimeConfig.INTERNAL_API_URL;
const INTERNAL_API_PROFILE_URL = publicRuntimeConfig.INTERNAL_API_PROFILE_URL;

const isServer = typeof window === 'undefined';

export const profileApiHost = LOCALHOST
  ? 'http://localhost:3000/otvety/api/proxy/profiling/'
  : isServer
  ? `${INTERNAL_API_PROFILE_URL}/profile`
  : `${UCHI_URL}/profiling`;

const apiHost = LOCALHOST ? 'http://localhost:3000' : `${UCHI_URL}`;

const fetchFactory = function (fetchOptions: RequestInit) {
  return async (input: RequestInfo | URL, options?: RequestInit) => {
    return fetch(input as string, {
      ...options,
      ...fetchOptions,
    });
  };
};

export const apiFetch = (cookie: string | undefined) => {
  // Server side req with cookie
  if (cookie) {
    return fetchFactory({
      headers: { cookie },
    });
  }

  // Client side req with credentials include
  return fetchFactory({
    credentials: 'include',
  });
};

export const profileApi = (ctx: NextPageContext | undefined = undefined) => {
  const cookie = ctx?.req?.headers?.cookie;
  return UserApiFactory({}, profileApiHost, apiFetch(cookie));
};

export const marusiaApi = (ctx: NextPageContext | undefined = undefined) => {
  const cookie = ctx?.req?.headers?.cookie;
  return MarusiaApiFactory({}, apiHost, apiFetch(cookie)); //
};

export const marusiaServerApi = (ctx: NextPageContext | undefined = undefined) => {
  const cookie = ctx?.req?.headers?.cookie;
  return MarusiaApiFactory({}, INTERNAL_API_URL, apiFetch(cookie)); //
};
